<template>
  <div class="container">
    <div class="broker-img">
      <img src="@assets/images/broker_img2.jpg" />
    </div>
    <div class="form_content">
      <p class="msg1">请填写需要寻找的酒款信息</p>
      <!--中文名称-->
      <div class="one">
        <label for="cn_name" style="color:#212121;font-size:14px">中文名称</label>
        <input
          type="text"
          placeholder="如：罗曼尼康帝"
          id="goods_cnName"
          v-model="cn_name"
          style="-webkit-appearance: none;"
        />
      </div>
      <span
        class="spa span1"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <!--英文名称-->
      <div class="two">
        <label for="en_name" style="color:#212121;font-size:14px">英文名称</label>
        <input
          type="text"
          placeholder="如：Romanee-Conti"
          id="goods_enName"
          v-model="en_name"
          style="-webkit-appearance: none;"
        />
      </div>
      <span
        class="spa span2"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <!--目标年份-->
      <div class="three">
        <label for="years" style="color:#212121;font-size:14px">目标年份</label>
        <input
          type="text"
          placeholder="如：1982,1995"
          id="years"
          v-model="years"
          style="-webkit-appearance: none;"
        />
      </div>
      <span
        class="spa span3"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <!--数量-->
      <div class="four">
        <label for="num" style="color:#212121;font-size:14px">数量</label>
        <input
          type="text"
          placeholder="请输入您需要的数量"
          id="accounts"
          v-model="accounts"
          style="-webkit-appearance: none;"
        />
      </div>
      <span
        class="spa span4"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <p class="msg2">请填写个人信息</p>
      <div class="five">
        <label for="num" style="color:#212121;font-size:14px">称谓*</label>
        <input
          type="text"
          placeholder="如：张三"
          id="username"
          v-model="username"
          style="-webkit-appearance: none;"
        />
        <label for style="color:#c72d2f;font-size:14px">(必填)</label>
      </div>
      <span
        class="spa span5"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <div class="six">
        <label for="num" style="color:#212121;font-size:14px">电话*</label>
        <input
          type="text"
          placeholder="请输入您的电话号码"
          id="phone"
          v-model="phone"
          style="-webkit-appearance: none;"
        />
        <label for style="color:#c72d2f;font-size:14px">(必填)</label>
      </div>
      <span
        class="spa span6"
        style="margin-left: 20px; display: none; font-size: 12px; color: red;"
      ></span>
      <div class="seven">
        <label for="num" style="color:#212121;font-size:14px">微信号</label>
        <input
          type="text"
          placeholder="请输入您的微信号"
          id="WeChat_num"
          v-model="WeChat_num"
          style="-webkit-appearance: none;"
        />
      </div>
      <div class="tijiao">
        <!--<input type="submit" value="提交" id="sub"/>-->
        <button value="提交" id="sub" class="notice" @click="subform">提交</button>
      </div>
    </div>
    <!-- 消息通知 -->
  </div>
</template>
<script>
import { postComment } from "@api/comment";

export default {
  name: "Zhaop",
  data: function() {
    return {
      WeChat_num: "",
      phone: "",
      username: "",
      accounts: "",
      years: "",
      en_name: "",
      cn_name: ""
    };
  },
  methods: {
    async subform() {
      if (this.phone.length < 5) {
        this.$dialog.error("请输入手机号码");
        return false;
      }
      var expect =
        "酒中文名" +
        this.cn_name +
        ",酒英文名" +
        this.en_name +
        ",年份" +
        this.years +
        "，数量" +
        this.accounts +
        ",联系人" +
        this.en_name +
        ",手机号码" +
        this.phone +
        ",微信号" +
        this.WeChat_num;

      postComment({
        comment: expect
      })
        .then(() => {
          this.$dialog.success("提交成功");
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 640px;
  margin: 0 auto 30px;
}
.form_content input {
  display: inline-block;
}
.msg1 {
  margin-left: 29px;
  color: #757575;
  font-size: 13px;
}
.msg2 {
  margin-top: 26px;
  margin-left: 29px;
  color: #757575;
  font-size: 13px;
}
.one,
.two,
.three,
.four,
.five,
.six,
.seven {
  width: 90%;
  margin: 17px auto 0;
  height: 33px;
  border-radius: 3px;
  border: 1px solid #eee;
}
.form_content div label {
  margin-left: 10px;
}
#goods_cnName,
#goods_enName,
#years,
#accounts,
#username,
#phone,
#WeChat_num {
  width: 60%;
  height: 33px;
  border-radius: 3px;
  outline: none;
  border: none;
  text-indent: 24px;
  -webkit-appearance: none;
}
#goods_cnName,
#goods_enName,
#years,
#accounts,
#username,
#phone,
#WeChat_num:focus {
  color: #212121;
}
/*提交按钮*/
.tijiao {
  width: 90%;
  margin: 17px auto 0;
  height: 33px;
  border-radius: 3px;
}
.tijiao button {
  width: 100%;
  color: #fff;
  background: #c7302f;
  font-size: 16px;
  height: 33px;
  border-radius: 3px;
  outline: none;
  border: none;
  text-align: center;
  -webkit-appearance: none;
}
.broker-img {
  width: 100%;
  height: 291px;
}
.broker-img img {
  width: 100%;
  height: 100%;
}
</style>